import { ROLE_LABELS } from '@/constants/permissions'
import type { SystemRole } from '@/types/permission.types'
import type { UserStatus } from '@/types/auth.types'
import { Badge, type BadgeProps } from '@/components/ui/badge'

const ROLE_VARIANT: Record<
  SystemRole,
  'default' | 'info' | 'secondary' | 'warning'
> = {
  super_admin: 'default',
  manager: 'info',
  assistant: 'secondary',
  salesman: 'warning',
}

export function RoleBadge({ role }: { role: SystemRole }) {
  return <Badge variant={ROLE_VARIANT[role]}>{ROLE_LABELS[role]}</Badge>
}

export function StatusBadge({ status }: { status: UserStatus }) {
  if (status === 'active') return <Badge variant="success">Active</Badge>
  if (status === 'inactive') return <Badge variant="warning">Inactive</Badge>
  return <Badge variant="destructive">Deleted</Badge>
}

/** Generic status chip for any module (orders, stock, invoices, …) */
export function AppStatusBadge({
  label,
  variant = 'secondary',
  dot,
}: {
  label: string
  variant?: BadgeProps['variant']
  dot?: boolean
}) {
  return (
    <Badge variant={variant} dot={dot}>
      {label}
    </Badge>
  )
}

import { documentStatusVariant } from '@/components/common/status-badge-utils'
export function DocumentStatusBadge({
  status,
}: {
  status: string | null | undefined
}) {
  const raw = (status ?? '').trim()
  const label = raw
    ? raw.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
    : '—'
  return (
    <AppStatusBadge label={label} variant={documentStatusVariant(status)} />
  )
}
